module.exports = __webpack_public_path__ + "img/icon-category-foodtruck.c202ddaf.png";